import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { AuthProvider } from '@/contexts/AuthContext'
import './index.css'
import { PostHogProvider } from 'posthog-js/react'

const isDev = import.meta.env.MODE === 'development'

const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
}

const Root = (
  <>
    {isDev ? (
      // no PostHog in development
      <AuthProvider>
        <App />
      </AuthProvider>
    ) : (
      <PostHogProvider apiKey={import.meta.env.VITE_POSTHOG_KEY} options={options}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </PostHogProvider>
    )}
  </>
)

ReactDOM.createRoot(document.getElementById('root')!).render(Root)
